{
  "endTime": "وقت الانتهاء",
  "startTime": "وقت البدء",
  "time": "الوقت"
}
